import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
// import { checkParams } from "../../../src/util/Util";
import Header from "../../components/header/Header";
import "./PatientLogin.css";
import { Context } from "../../context/Context";
import SignupModal from './SignupModal';

const PatientLogin = (props) => {
  //localStorage.removeItem("userCompanyData");
  const { clearAllData } = useContext(Context);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passVisible, setPassVisible] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [nextQuest, setNextQuest] = useState(false);
  const [modalSignup, setModalSignup] = useState(false);
  const [formError, setFormError] = useState(null);
  const [loginType, setLoginType] = useState(null)

  useEffect(() => {
    clearAllData();
  }, [])

  let navigate = useNavigate();

  const handlePhone = (subjectString) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    setErrorPhone("");

    if (phoneRegex.test(subjectString)) {
      var formattedPhoneNumber = subjectString.replace(phoneRegex, "($1) $2-$3");
      setPhone(formattedPhoneNumber);
    } else {
      setErrorPhone("Please enter a valid US mobile number.");
      setPhone(subjectString);
    }
  };

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
    localStorage.removeItem("isNew");
    if (localStorage.getItem("nextQuestionnaire") === "1") {
      setNextQuest(true);
      localStorage.removeItem("nextQuestionnaire");
    }
  }, [props]);

  useEffect(() => {
    window.onbeforeunload = null;
  }, []);

  const handleSignIn = (e) => {
    e.preventDefault();
    var sendObj = { email: email.trim(), password: password, cloud: true };
    var route = "user/login";
    if (phone.length > 0) {
      sendObj = { phone };
      route = "user/phone_login";
    }
    axios
      .post(window.ajaxLink + route, sendObj)
      .then((res) => {
        if (res.data.responseCode === 200) {
          if (res.data.responseData.self_user === 1) {
            // Redirecting user to external site if self_user === 1
            const fromSite = localStorage.getItem("fromSite") || 'https://www.startfreept.com';
            window.location.href = fromSite + `/?userId=${res.data.responseData.id}&userToken=${res.data.responseData.token}`;
            return;
          }
          if (phone.length > 0) {
            localStorage.setItem("phone", phone);
            navigate("/phone_login");
          } else {
            localStorage.setItem("userData", JSON.stringify(res.data.responseData));
            props.checkLoggedIn(true);

            if (!res.data.responseData.is_otp_verified) {
              navigate("/verify");
            } else if (res.data.responseData.company_admin === 1 && res.data.responseData.user_type !== 2) {
              navigate("/settings");
            } else if (res.data.responseData.user_type === 2) {
              navigate("/dashboard");
            } else if (nextQuest) {
              navigate("/questionnaire/2");
            } else {
              navigate("/initial_questionare");
            }
          }
        }
      })
      .catch((error) => {
        if (phone.length > 0 && error.response) {
          setErrorPhone(error.response.data.errorData);
          setErrorEmail("");
          setErrorPassword("");
        }

        if (error.response.data.responseCode === 400) {
          setErrorEmail("Invalid email address!");
          setErrorPassword("");
        }
        if (
          error.response.data.errorData ===
          "You have to accept invitation that we sent you to email in order to proceed!"
        ) {
          setErrorEmail(error.response.data.errorData);
          setErrorPassword("");
        }
        if (error.response.data.responseCode === 401) {
          setErrorPassword("Invalid password!");
          setErrorEmail("");
        }
        if (error.response.data.errorData === "Email is invalid!") {
          setErrorEmail("Invalid email address!");
          setErrorPassword("");
        }
        if (error.response.data.errorData === "Email field is required!") {
          setErrorEmail(error.response.data.errorData);
          setErrorPassword("");
        }
        if (error.response.data.errorData === "Password field is required!") {
          setErrorEmail("");
          setErrorPassword(error.response.data.errorData);
        }
        if (error.response.data.errorData === "Password and email field is required!") {
          setErrorEmail("Email field is required!");
          setErrorPassword("Password field is required!");
        }
        if (error.response.data.responseCode === 404) {
          setFormError(error.response.data.errorData || "Error signing in user.")
        }
      });
  };
  return (
    <>
      <Header />
      <div className="memberRegisterContainer patientLoginContainer">
        <form className="patientLoginHolder max-w-[550px] pb-12" onSubmit={(e) => handleSignIn(e)}>
          <div className="sign_title signTitlePatient mb-12">Sign in to Virdio Health</div>
          <div className="info_row_holder">


            <div className="form_title patientBelowSeparate">Sign in with email or phone</div>
            <div className="relative_holder">
              <input
                type="text"
                tabIndex="1"
                value={loginType === "phone" ? phone : email}
                placeholder="e.g. john@email.com or 202-333-2222"
                className="gray_inputs gray_inputs_login inputsPatientLogin w-full"
                onChange={(e) => {
                  const value = e.currentTarget.value;

                  if (!value) {
                    setLoginType(null);
                    setPhone("");
                    setEmail("");
                    return;
                  }

                  const isPhoneStart = /^[0-9+\-()]/.test(value.charAt(0));

                  if (isPhoneStart) {
                    setLoginType("phone");
                    handlePhone(value);
                  } else {
                    setLoginType("email");
                    setEmail(value);
                  }
                }}
              />
              {loginType === "phone"
                ? errorPhone && <div className="email_error_msg">{errorPhone}</div>
                : errorEmail && <div className="email_error_msg">{errorEmail}</div>}
            </div>


            {
              loginType === "email" &&
              <>
                <div className="form_title">Password</div>
                <div style={{ marginTop: "0px" }} className="form_title form_forgot" onClick={() => navigate("/forgotpassword")}>
                  Forgot password?
                </div>
                <div className="relative_holder relative">
                  <input
                    type={passVisible ? "text" : "password"}
                    className="gray_inputs gray_inputs_login inputsPatientLogin w-full"
                    onChange={(e) => setPassword(e.currentTarget.value)}
                  />
                  <div className="eye_show absolute" onClick={() => setPassVisible(!passVisible)}>
                    {passVisible && <div className="crossed_eye"></div>}
                  </div>
                </div>

                <>{errorPassword && <div className="email_error_msg">{errorPassword}</div>}</>
              </>
            }

            {
              formError &&
              <div className="email_error_msg" style={{ marginTop: '1rem', paddingBottom: '0rem' }}>{formError}</div>
            }
          </div>
          <div className="bottomLoginPadding">
            <button type="submit" className="signNewButton signNew_login">
              Sign In
            </button>
          </div>
          <div className="bottomLoginPadding">
            <div className="dontHaveAccount">Don't have an account? </div>
            <div className="dontHaveAccount signUpLink">
              <div onClick={() => { setModalSignup(true); }}> Sign up</div>
            </div>
          </div>
        </form>
      </div>
	  
	  {modalSignup && <SignupModal onConfirm={() => { window.location = 'https://startfreept.com/'; }} onCancel={() => setModalSignup(false)} />}
    </>
  );
};

export default PatientLogin;
